import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { DELETE_JOB_PREFERENCES_MUTATION } from "../queries";
import { showSnackbar } from "@/lib/snackbarUtils";

export default function DeleteJobPreferencesModal({
  open,
  setOpen,
  jobPreferencesId,
  refetchPreferences
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  jobPreferencesId: string | undefined;
  refetchPreferences: () => void;
}) {
  const [deleteJobPreferences, { loading }] = useMutation(DELETE_JOB_PREFERENCES_MUTATION);

  const handleSubmit = useCallback(async () => {
    try {
      const { data } = await deleteJobPreferences({ variables: { jobPreferencesId } });

      if (data?.deleteJobPreferences?.success) {
        showSnackbar("Job Preferences deleted successfully");
        setOpen(false);
        refetchPreferences();
      } else {
        showSnackbar(
          data?.deleteJobPreferences?.message || "There was a problem deleting these Job Preferences. Try again later."
        );
      }
    } catch (error) {
      showSnackbar("There was a problem deleting these Job Preferences. Try again later.");
    }
  }, [deleteJobPreferences, jobPreferencesId, refetchPreferences, setOpen]);

  return (
    <Dialog
      open={open}
      headline="Delete Job Preferences"
      className="w-[490px] p-6 pr-2"
      actions={
        <>
          <Button
            variant="text"
            onClick={() => {
              setOpen(false);
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="filled"
            theme="error"
            trailingIcon={false}
            icon={loading ? "progress_activity" : "delete"}
            onClick={handleSubmit}
            disabled={loading}
            data-testid="confirm-delete-job-preferences"
          >
            Delete
          </Button>
        </>
      }
    >
      <p>
        <span>{"Are you sure you want to delete this person's Job Preferences?"}</span>
        <span>{"This cannot be undone."}</span>
      </p>
    </Dialog>
  );
}
